























import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";

@Component
export default class BasketNotifications extends Mixins(Context) {
  // Inject
  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  public isProcessing = false;

  // Provider
  public get basketData() {
    return this.$basketData();
  }

  public get basket() {
    return this.$_.get(this.basketData, "basket");
  }

  public get showWarningNotes() {
    return (
      !this.$_.isEmpty(this.warningNotes) &&
      !this.$_.get(this.basketData, "basketIsComplete")
    );
  }

  public get warningNotes() {
    return this.$_.filter(this.$_.get(this.basket, "warning_notes", []), [
      "is_hidden",
      false
    ]);
  }

  public async hideNotifications() {
    this.isProcessing = true;
    await this.$basketMethods.hideWarnings(
      this.warningNotes.map(note => note.id)
    );
    this.isProcessing = false;
  }
}
